// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"5b6ac701","235":"113537fe","307":"d5a76e1a","383":"d733d6f6","427":"4d494328","453":"e1ea8cda","489":"e74fa131","572":"f4b0cfba","669":"dbbaf0e9","706":"54624c7d","723":"93635840","929":"052f4b7f"}[chunkId] + ".chunk.js";
};